export const getTimeInMinutes = (utcString, currentTime) => {
  const date = new Date(utcString);
  if (currentTime < date) {
    return 0;
  }
  const timeDifferenceMilliseconds = currentTime - date;
  const timeDifferenceMinutes = Math.floor(timeDifferenceMilliseconds / (1000 * 60));
  return timeDifferenceMinutes;
};